import * as React from 'react'
import { Button } from '$views/components'
import { routeProvider } from '$utils/routeProvider'
import history from '$utils/history'

interface Props {
  label: string
}

export const ButtonError404: React.SFC<Props> = ({ label }) => {
  return (
    <Button primary onClick={() => history.push(routeProvider.mainPage)} fluid>
      {label}
    </Button>
  )
}



// WEBPACK FOOTER //
// ./src/views/Error404/ButtonError.tsx